import { UniformSlot } from "@uniformdev/canvas-react";

import { ScrollToEnlarge } from "@/libraries/design/components";

const UniformHeroScrollToEnlargeContainer = () => {
    return (
        <ScrollToEnlarge>
            <UniformSlot name="content" />
        </ScrollToEnlarge>
    );
};

export default UniformHeroScrollToEnlargeContainer;
